export default function isChunkLoadError(error?: Error): boolean {
  if (!error) return false;

  return (
    error.name === 'ChunkLoadError' ||
    error.message?.startsWith('Loading chunk')
  );
}
